// extracted by mini-css-extract-plugin
export var label = "_ex-2";
export var slideContainer = "_ex-0";
export var slider = "_ex-1";